import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { auditLogEntrySchema } from '../models/auditLogEntry.schema';
import { auditLogListQuerySchema } from './list.schema';

export type AuditLogListQuery = PaginationQuery & {
  objectType?: Array<string>;
  objectId?: Array<number>;
  // The endpoint rejects `ordering`; wire order is oldest-first.
  action?: Array<string>;
};

// audit_logs is cursor-paginated: the envelope carries only next/previous —
// no total/totalPages — so the shared listResponse (which requires both) does not fit.
const auditLogListResponseSchema = z.object({
  pagination: z.object({
    next: z.string().nullable(),
    previous: z.string().nullable(),
  }),
  results: z.array(auditLogEntrySchema),
});

export const list = (query: AuditLogListQuery = {}) => {
  return {
    endpoint: `/audit_logs`,
    method: 'GET',
    responseSchema: auditLogListResponseSchema,
    query,
    querySchema: auditLogListQuerySchema,
  } as const;
};
